export default __webpack_public_path__ + "static/media/zainLogo.4ca96fbc.svg";